import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  boxShadow: 'none',
  padding: (p) => p.spacing(1.25, 1.5),
  gap: (p) => p.spacing(1),
  flex: 1,
};

export const header: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
};

export const iconWrapper: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: (p) => p.spacing(2.5),
  width: (p) => p.spacing(2.5),
  borderRadius: '100%',
  backgroundColor: (p) => p.palette.primary[500],
};

export const valueWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const skeleton: SxStyle = {
  height: (p) => p.spacing(3.75),
  width: (p) => p.spacing(6),
};
